import { useState } from 'react';

interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || (i >= current - 1 && i <= current + 1)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...');
    }
  }

  if (total <= 1) return null;

  return (
    <nav className="flex items-center justify-center gap-1 mt-10" aria-label="分页导航">
      <button
        onClick={() => onChange(current - 1)}
        disabled={current === 1}
        className="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-medium transition-colors disabled:opacity-30 disabled:cursor-not-allowed text-foreground-600 hover:bg-background-100"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {pages.map((page, idx) =>
        typeof page === 'string' ? (
          <span key={`dots-${idx}`} className="w-9 h-9 flex items-center justify-center text-sm text-foreground-400">
            ...
          </span>
        ) : (
          <button
            key={page}
            onClick={() => onChange(page)}
            className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-medium transition-colors ${
              page === current
                ? 'bg-primary-500 text-white'
                : 'text-foreground-600 hover:bg-background-100'
            }`}
          >
            {page}
          </button>
        )
      )}
      <button
        onClick={() => onChange(current + 1)}
        disabled={current === total}
        className="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-medium transition-colors disabled:opacity-30 disabled:cursor-not-allowed text-foreground-600 hover:bg-background-100"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}